export default __webpack_public_path__ + "static/media/offroad80000.1f81a380.jpg";